import { Alert, theme } from "antd";
import { ReactElement } from "react";
import CenterContent from "../layouts/CenterContent";

const NoAccessScreen = (): ReactElement => {
  const { token } = theme.useToken();

  return (
    <CenterContent $backgroundColor={token.colorBgContainer} $color={token.colorText} $padding={token.padding}>
      <Alert
        showIcon
        type="error"
        message="You do not have access to the Agent App. Please contact your supervisor regarding this issue."
      />
    </CenterContent>
  );
};

export default NoAccessScreen;
